import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { unwrapArray } from '../lib/api-envelope';
import { comparePositions, toPosition, type Position } from '../types/position';

/**
 * The tenant's positions, normalized and in the API's order.
 *
 * The two answers live under DIFFERENT keys — `['positions']` (active only,
 * what a picker offers) and `['positions', 'all']` (the management view, and
 * any screen that must name a deactivated position someone still holds). Both
 * sit under the `['positions']` prefix, so one invalidation refreshes both.
 */
export function usePositions({ includeInactive = false }: { includeInactive?: boolean } = {}) {
  return useQuery<Position[]>({
    queryKey: includeInactive ? ['positions', 'all'] : ['positions'],
    queryFn: () =>
      api.positions.list(includeInactive).then((r) =>
        unwrapArray<any>(r.data)
          .map(toPosition)
          .filter((p): p is Position => p !== null)
          .sort(comparePositions),
      ),
  });
}
